import React from "react";

function ActiveReview(){
  return(
    <div className="verify-state-box">
    <div className="verify-state-inner">
      <div className="verify-state-icon"><span></span><span></span><span></span></div>
      <p>Review Successfully</p>
      
    </div>
  </div>
            
  )
}
export default ActiveReview;